/**
 * A coarse, stable label for a failed request.
 *
 * Deliberately not the server's message. Messages are localised, they get
 * reworded, and they can quote the user's own input back — which would put
 * personal data in an event property (BR-44). A status code groups failures the
 * way a dashboard needs to read them and cannot leak anything.
 */
export const apiErrorCode = (error: unknown): string => {
  const status = (error as { response?: { status?: number } })?.response?.status

  if (typeof status === 'number') return String(status)
  if (error instanceof Error && error.name) return error.name

  return 'unknown'
}
